//TODO: eventually delete this file
export const login = {
  landing: {
    title: "Principal and Rater Portal",
    importantTitle: "Important information",
    applyName: "University of Tasmania",
    srpLink: "https://www.utas.edu.au/study/schools-recommendation-program",
    applyLink:
      "https://www.utas.edu.au/?gclid=EAIaIQobChMI89WaxZmN9wIVwn0rCh0mbw_iEAAYASAAEgLfo_D_BwE&gclsrc=aw.ds",
    contactLink: "https://www.uac.edu.au",
    heroImageAltText:
      "Three Marine and Antarctic students walking together at Binalong Bay, located in East Tasmania, with the water and coastline behind them",
    instructionText1:
      "Welcome to the Principal and Rater Portal for the University of Tasmania’s Schools Recommendation Program.  This is where you can support your students’ applications and help them secure an early offer to study in 2023.",
    instructionText2: "To access the portal enter your registered email address and password."
  },
  resetPassword: {
    success: "Password is updated!",
    invalidToken: "Your link has expired",
    backButton: "Back to landing page",
    failValidation: "You haven't met the password requirements yet"
  },
  maintenance: {
    title: "Down for Maintenance",
    message: "Access is currently down for maintenance."
  },
  school: {
    title: "Log in",
    resetPassword: "Please contact your principal to make changes to your password."
  },
  failLogin: "Login failed. Please check your username and password."
};

export const common = {
  header: {
    title: "Schools Recommendation Program 2022",
    logoAltText: "University of Tasmania logo"
  },
  footer: {
    copyright: "© 2022 UAC",
    companyName: "The Universities Admissions Centre (NSW & ACT) Pty Ltd",
    abn: "ACN 070 055 935 ABN 19 070 055 935"
  },
  utasEmailAddress: "student.recruitment@utas.edu.au",
  emailSent:
    "Email has been sent. Please also check your spam folder and add course.info@utas.edu.au to your 'Safe Sender' list.",
  emailFail: "Fail to send an email. Please try again to reset the email.",
  errorTitle: "Server error",
  loadingError: "Could not load the data. Please restart the application.",
  savingError: "Could not save the data.",
  deletingError: "Could not delete the data.",
  failAsync: "Fail to operate data.",
  uploadFileErrorTitle: "Failed to upload the file.",
  failDocUpload: "Could not upload document.",
  badRequestError: "We were unable to action your request",
  authError:
    "Unable to process your request. Your session may have timed out. Please login before you try again.",
  serverError: "Unable to process your request. Please try again, or contact us for assistance.",
  refreshTokenAlert: "We were unable to action your last request, please try again.",
  dummy:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
};

export const schoolUser = {
  unsavedChange: "You have unsaved changes. Are you sure you want to leave?",
  dashboard: {
    uni: "University of Tasmania",
    totalStudentLabel: "Year 12 students",
    totalAppliedUTASLabel: "University of Tasmania applications",
    totalAppliedSRPLabel: "SRP applications",
    unratedApplicantsLabel: "Unrated SRP applications",
    partiallyRatedApplicantsLabel: "Draft SRP ratings"
  },
  settings: {
    desc: "Make an update to your own details, or reset your password here. You cannot update your role here. Please contact us via the enquiry form if you wish to move from a Principal User to a Rater or Rater to Principal."
  },
  reportSettings: {
    unsavedChange: "You have unsaved changes. Are you sure you want to leave?"
  }
};

export const principal = {
  credential: {
    addModal: {
      displayDesc: "The rater has been created. A set password email has been sent to",
      displayInfo: "The user will be able to update their own contact information and name."
    },
    deleteModal: {
      warning: "This cannot be undone. Are you sure you wish to delete this User?"
    },
    passwordModal: {
      modalDesc:
        "They will have a chance to set a new password via the email sent to the above address.",
      warning: "This cannot be undone. Are you sure you wish to reset the User's password?"
    }
  }
};

export const rater = {
  credential: {
    noRaterForResetPassword: "Please select the rater."
  },
  rating: {
    desc: "Please provide ratings for the student selected below on each of the criteria. A rating for each criteria is required before you can continue, but you can save your draft rating at any time.",
    desc2: "Make sure that the student’s details are correct before continuing.",
    comment:
      "Please provide any further information that you would like the University of Tasmania to consider in assessing this student for admission to university.",
    ASCIIError:
      "You must remove the special characters from your comment above before your Rating can be submitted."
  },
  qual: {
    title: "Qualification Details",
    noQual: "No qualification was found for this student.",
    saveDraftInfo: "Your document will be discarded.",
    document:
      "Please provide any relevant documents that you may wish for the University of Tasmania to consider. ",
    uploadDoc: "Drop a file here or click to upload",
    uploadDocMaxSize: "Only PDF files are accepted. Each document must not exceed 5MB."
  }
};
